// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"afeaaa01","155":"a0505ad7","159":"7d4f3310","224":"4c17d209","283":"34f7a130","352":"7da8ff96","717":"c931ca78","886":"78ed09a3"}[chunkId] + ".chunk.js";
};